import React from 'react';
import { FiHeart, FiShield, FiUsers } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const AboutCenter = () => {
  return (
    <section id="about" className="py-16 lg:py-24 bg-gradient-to-br from-emerald-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          
          {/* Left Image */}
          <div className="relative">
            <div className="bg-white rounded-3xl p-2 sm:p-4 shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600&h=500&fit=crop"
                alt="JIVA NADI Therapy Center"
                className="w-full h-56 sm:h-72 lg:h-96 object-cover rounded-2xl"
              />
            </div>
            {/* <div className="absolute -bottom-6 -right-6 bg-emerald-600 text-white rounded-2xl p-6 shadow-xl">
              <div className="text-center">
                <div className="text-2xl font-bold">15+</div>
                <div className="text-sm">Years Trust</div>
              </div>
            </div> */}
          </div>

          {/* Right Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                Mumbai's Premier
                <span className="text-emerald-600 block">Non-Surgical Healing Center</span>
              </h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                At JIVA NADI Therapy & Chiropractor Center, we believe in the body's natural ability to heal. 
                Our comprehensive approach combines ancient wisdom with modern techniques to provide 
                drug-free, surgery-free pain relief solutions.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
                  <SafeIcon icon={FiHeart} className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Holistic Healing Philosophy</h3>
                  <p className="text-gray-700">We treat the root cause, not just symptoms, ensuring long-lasting relief and improved quality of life.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
                  <SafeIcon icon={FiShield} className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Non-Invasive Treatments</h3>
                  <p className="text-gray-700">Our proven methods eliminate the need for surgery or heavy medications, focusing on natural healing processes.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center">
                  <SafeIcon icon={FiUsers} className="w-6 h-6 text-emerald-600" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Personalized Care</h3>
                  <p className="text-gray-700">Every treatment plan is tailored to your specific condition, lifestyle, and healing goals for optimal outcomes.</p>
                </div>
              </div>
            </div>

            <button className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-xl">
              Learn More About Our Approach
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCenter;